/**
 * ege-stress-ui.js — экран /udareniya-ege: карточки, задание 4, тест, список.
 * Логика без DOM — ege-stress-core.js (EgeStressCore), данные и тексты страница
 * кладёт в window.__EGE = {T, data, audioUrl, shareUrl, slug}.
 *
 * Прогресс карточек живёт в localStorage этого браузера (удобство одного
 * человека, а не обещание): без хранилища тренажёр работает, просто забывает.
 */
(function () {
    'use strict';

    var CFG = window.__EGE || {};
    var T = CFG.T || {};
    var C = window.EgeStressCore;
    var app = document.getElementById('egApp');
    var panel = document.getElementById('egPanel');
    if (!C || !app || !panel || !CFG.data) return;

    var SLUG = CFG.slug || 'udareniya-ege';
    var STORE_KEY = 'tmb_ege_stress_v1';
    var LIST = C.items(CFG.data);
    var BY_ID = {};
    LIST.forEach(function (it) { BY_ID[it.id] = it; });
    var SECTION_TITLES = {};
    (CFG.data.sections || []).forEach(function (s) { SECTION_TITLES[s.id] = s.title; });

    function tr(key, vars) {
        var s = T[key] || key;
        if (vars) for (var k in vars) if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split(':' + k).join(vars[k]);
        return s;
    }
    function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
    }
    function stage(name, data) {
        try { if (window.__stage) window.__stage(name); } catch (_) {}
        try { if (window.__aeFunnel) window.__aeFunnel(name, data || {}); } catch (_) {}
    }
    function complete(payload) {
        try { if (window.__aeToolComplete) window.__aeToolComplete(payload); } catch (_) {}
    }
    function toast(msg, type) {
        if (window.__toast) window.__toast(msg, type || 'info');
    }

    // ── хранилище прогресса ───────────────────────────────────────────────
    var state = C.emptyState();
    try { state = C.restore(window.localStorage.getItem(STORE_KEY)); } catch (_) {}
    function save() {
        try { window.localStorage.setItem(STORE_KEY, JSON.stringify({ v: 1, cards: state.cards })); } catch (_) {}
    }

    // ── озвучка: один элемент на страницу, первое play() — внутри нажатия ──
    // Элемент, сыгравший в жесте, сохраняет право играть дальше (см.
    // audio-gate.js), поэтому формы строки идут одна за другой по 'ended'.
    var audioEl = null, audioQueue = [], audioOff = false;
    function audioUrl(form) { return CFG.audioUrl + '?w=' + encodeURIComponent(form); }
    function playForms(forms) {
        if (audioOff || !CFG.audioUrl || !forms || !forms.length) return;
        if (!audioEl) {
            audioEl = new Audio();
            audioEl.preload = 'auto';
            audioEl.addEventListener('ended', function () {
                if (!audioQueue.length) return;
                setTimeout(function () { playNext(); }, 250);
            });
            audioEl.addEventListener('error', function () {
                audioQueue = [];
                audioOff = true;
                document.body.classList.add('eg-no-audio');
                toast(tr('audio_unavailable'), 'warning');
            });
        }
        audioQueue = forms.slice();
        playNext();
    }
    function playNext() {
        var f = audioQueue.shift();
        if (!f || !audioEl) return;
        audioEl.src = audioUrl(f);
        var p = audioEl.play();
        if (p && p.catch) p.catch(function () { audioQueue = []; });
    }
    function sayButton(forms) {
        var b = el('button', 'eg-say');
        b.type = 'button';
        b.setAttribute('aria-label', tr('listen'));
        b.title = tr('listen');
        b.textContent = '🔊';
        b.addEventListener('click', function () { playForms(forms); });
        return b;
    }

    // ── режимы ────────────────────────────────────────────────────────────
    var tabs = app.querySelectorAll('[data-eg-mode]');
    var mode = 'cards';
    try { if (window.__toolSettings) mode = window.__toolSettings.load(SLUG, 'mode', 'cards') || 'cards'; } catch (_) {}
    if (['cards', 'exam', 'test'].indexOf(mode) < 0) mode = 'cards';
    Array.prototype.forEach.call(tabs, function (b) {
        b.addEventListener('click', function () { setMode(b.getAttribute('data-eg-mode')); });
    });
    function setMode(m) {
        mode = m;
        Array.prototype.forEach.call(tabs, function (b) {
            var on = b.getAttribute('data-eg-mode') === m;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'mode', m); } catch (_) {}
        stage(m);
        if (m === 'cards') renderCards();
        else if (m === 'exam') renderExam();
        else renderTestStart();
    }

    // ── карточка: слово, гласные — кнопки ─────────────────────────────────
    function wordButtons(item, onPick) {
        var box = el('div', 'eg-word');
        var word = C.bare(item), slots = C.vowelSlots(item), n = 0;
        for (var i = 0; i < word.length; i++) {
            var at = slots.indexOf(i);
            if (at < 0) { box.appendChild(el('span', 'eg-l', word[i])); continue; }
            var b = el('button', 'eg-vbtn', word[i]);
            b.type = 'button';
            b.setAttribute('data-ord', String(at));
            b.setAttribute('aria-label', tr('vowel_aria', { v: word[i], n: String(at + 1) }));
            (function (ord) { b.addEventListener('click', function () { onPick(ord, box); }); })(at);
            box.appendChild(b);
            n++;
        }
        return box;
    }
    function markWord(box, item, picked) {
        Array.prototype.forEach.call(box.querySelectorAll('.eg-vbtn'), function (b) {
            var ord = +b.getAttribute('data-ord');
            b.disabled = true;
            if (ord === item.ord) b.classList.add('is-right');
            else if (ord === picked) b.classList.add('is-wrong');
        });
    }
    function stressedHtmlNode(item) {
        // верное ударение — буква списка заглавной, как у ФИПИ
        var s = el('span', 'eg-answer');
        var shownWord = C.shown(item, item.ord);
        for (var i = 0; i < shownWord.length; i++) {
            var ch = shownWord[i];
            if (/[АЕЁИОУЫЭЮЯ]/.test(ch)) s.appendChild(el('b', 'eg-v', ch));
            else s.appendChild(document.createTextNode(ch));
        }
        return s;
    }

    var cardFilter = 'all';
    function cardPool() {
        if (cardFilter === 'all') return LIST;
        if (cardFilter === 'weak') {
            return LIST.filter(function (it) { var c = state.cards[it.id]; return c && c.w > 0 && c.b < 2; });
        }
        return LIST.filter(function (it) { return it.section === cardFilter; });
    }

    function renderCards() {
        panel.innerHTML = '';
        var bar = el('div', 'eg-bar');
        var lab = el('label', 'eg-flabel', tr('cards_filter'));
        var sel = el('select', 'eg-select');
        sel.id = 'egFilter';
        lab.setAttribute('for', 'egFilter');
        [['all', tr('filter_all')]].concat((CFG.data.sections || []).map(function (s) { return [s.id, s.title]; }))
            .concat([['weak', tr('filter_weak')]]).forEach(function (o) {
                var op = el('option', null, o[1]); op.value = o[0]; if (o[0] === cardFilter) op.selected = true; sel.appendChild(op);
            });
        sel.addEventListener('change', function () { cardFilter = sel.value; renderCards(); });
        bar.appendChild(lab); bar.appendChild(sel);
        panel.appendChild(bar);

        var pool = cardPool();
        if (!pool.length) {
            panel.appendChild(el('p', 'eg-empty', tr('weak_empty')));
            panel.appendChild(progressLine());
            return;
        }
        var item = C.nextCard(state, pool, Date.now(), Math.random);
        var card = el('div', 'eg-cardbox');
        card.appendChild(el('p', 'eg-prompt', tr('cards_prompt')));
        var hint = el('p', 'eg-hint', item.hint);
        var fb = el('div', 'eg-feedback');
        fb.setAttribute('role', 'status');
        var next = el('button', 'eg-btn eg-btn-primary', tr('next'));
        next.type = 'button';
        next.hidden = true;
        next.addEventListener('click', function () { renderCards(); });
        var box = wordButtons(item, function (ord) {
            var ok = ord === item.ord;
            C.grade(state, item.id, ok, Date.now());
            save();
            markWord(box, item, ord);
            fb.innerHTML = '';
            var line = el('p', ok ? 'eg-ok' : 'eg-bad');
            if (ok) {
                line.textContent = tr('right') + ' ';
                line.appendChild(stressedHtmlNode(item));
            } else {
                var parts = tr('wrong', { word: '\u0000' }).split('\u0000');
                line.appendChild(document.createTextNode(parts[0]));
                line.appendChild(stressedHtmlNode(item));
                if (parts[1]) line.appendChild(document.createTextNode(parts[1]));
            }
            line.appendChild(document.createTextNode(' '));
            line.appendChild(sayButton([item.form]));
            fb.appendChild(line);
            var src = el('p', 'eg-src-line');
            src.appendChild(el('span', 'eg-src-k', tr('from_list') + ' '));
            src.appendChild(lineNode(item.line));
            fb.appendChild(src);
            next.hidden = false;
            next.focus({ preventScroll: true });
            updateProgress();
            stage(ok ? 'card_right' : 'card_wrong');
        });
        card.appendChild(box);
        card.appendChild(hint);
        card.appendChild(fb);
        card.appendChild(next);
        panel.appendChild(card);
        panel.appendChild(progressLine());
    }

    function lineNode(line) {
        var s = el('span', 'eg-line');
        for (var i = 0; i < line.length; i++) {
            var ch = line[i];
            if (/[АЕЁИОУЫЭЮЯ]/.test(ch)) s.appendChild(el('b', 'eg-v', ch));
            else s.appendChild(document.createTextNode(ch));
        }
        return s;
    }

    var resetArmed = false;
    function progressLine() {
        var wrap = el('div', 'eg-progress');
        var p = el('span', 'eg-progress-t');
        p.id = 'egProgress';
        wrap.appendChild(p);
        var reset = el('button', 'eg-link', tr('reset'));
        reset.type = 'button';
        reset.addEventListener('click', function () {
            if (!resetArmed) { resetArmed = true; reset.textContent = tr('reset_confirm'); return; }
            resetArmed = false;
            state = C.emptyState();
            save();
            toast(tr('reset_done'), 'success');
            renderCards();
        });
        wrap.appendChild(reset);
        setTimeout(updateProgress, 0);
        return wrap;
    }
    function updateProgress() {
        var p = document.getElementById('egProgress');
        if (!p) return;
        var s = C.progress(state, LIST);
        p.textContent = tr('progress', { sure: String(s.sure), total: String(s.total), weak: String(s.weak) });
    }

    // ── задание 4 ─────────────────────────────────────────────────────────
    var examStats = { n: 0, points: 0 };
    function renderExam() {
        panel.innerHTML = '';
        var task = C.examTask(LIST, Math.random);
        var box = el('div', 'eg-exam');
        box.appendChild(el('p', 'eg-prompt', tr('exam_instruction')));
        var ol = el('ol', 'eg-exam-list');
        var checks = [];
        task.words.forEach(function (w, i) {
            var li = el('li', 'eg-exam-row');
            var id = 'egX' + i;
            var cb = el('input'); cb.type = 'checkbox'; cb.id = id; cb.value = String(i + 1);
            var lab = el('label', 'eg-exam-word'); lab.setAttribute('for', id);
            lab.appendChild(el('span', 'eg-exam-n', (i + 1) + ')'));
            lab.appendChild(lineNode(w.text));
            li.appendChild(cb); li.appendChild(lab);
            var res = el('span', 'eg-exam-res');
            li.appendChild(res);
            ol.appendChild(li);
            checks.push({ cb: cb, res: res, w: w, li: li });
        });
        box.appendChild(ol);
        var fb = el('div', 'eg-feedback'); fb.setAttribute('role', 'status');
        var btn = el('button', 'eg-btn eg-btn-primary', tr('exam_check')); btn.type = 'button';
        var nextBtn = el('button', 'eg-btn', tr('exam_next')); nextBtn.type = 'button'; nextBtn.hidden = true;
        nextBtn.addEventListener('click', renderExam);
        btn.addEventListener('click', function () {
            var picked = checks.filter(function (c) { return c.cb.checked; }).map(function (c) { return +c.cb.value; });
            if (!picked.length) { toast(tr('exam_pick_first'), 'warning'); return; }
            var r = C.checkExam(task, picked);
            examStats.n++; examStats.points += r.point;
            checks.forEach(function (c) {
                c.cb.disabled = true;
                c.li.classList.add(c.w.right ? 'is-right' : 'is-wrong');
                c.res.innerHTML = '';
                if (c.w.right) c.res.textContent = tr('exam_row_right');
                else {
                    var parts = tr('exam_row_wrong', { word: '\u0000' }).split('\u0000');
                    c.res.appendChild(document.createTextNode(parts[0]));
                    c.res.appendChild(stressedHtmlNode(c.w.item));
                    if (parts[1]) c.res.appendChild(document.createTextNode(parts[1]));
                }
                c.res.appendChild(document.createTextNode(' '));
                c.res.appendChild(sayButton([c.w.item.form]));
            });
            fb.innerHTML = '';
            fb.appendChild(el('p', r.point ? 'eg-ok' : 'eg-bad',
                r.point ? tr('exam_point', { answer: r.answer }) : tr('exam_zero', { answer: r.answer, given: r.given })));
            fb.appendChild(el('p', 'eg-muted', tr('exam_score', { n: String(examStats.n), points: String(examStats.points) })));
            btn.hidden = true; nextBtn.hidden = false;
            nextBtn.focus({ preventScroll: true });
            // задание решено — это и есть выданный результат режима
            complete({ mode: 'exam', point: r.point });
        });
        var row = el('div', 'eg-actions'); row.appendChild(btn); row.appendChild(nextBtn);
        box.appendChild(row);
        box.appendChild(fb);
        panel.appendChild(box);
    }

    // ── тест ──────────────────────────────────────────────────────────────
    function renderTestStart() {
        panel.innerHTML = '';
        var box = el('div', 'eg-center');
        box.appendChild(el('p', 'eg-lead', tr('test_intro')));
        var b = el('button', 'eg-btn eg-btn-primary', tr('test_start')); b.type = 'button';
        b.addEventListener('click', function () { runTest(C.testSet(LIST, 20, Math.random)); });
        box.appendChild(b);
        panel.appendChild(box);
    }
    function runTest(set) {
        var i = 0, answers = [];
        stage('test_start');
        function step() {
            panel.innerHTML = '';
            if (i >= set.length) return finish();
            var item = set[i];
            var card = el('div', 'eg-cardbox');
            card.appendChild(el('p', 'eg-muted', tr('test_progress', { i: String(i + 1), n: String(set.length) })));
            var bar = el('div', 'eg-bar-prog'); var f = el('div', 'eg-bar-fill');
            f.style.width = Math.round(i / set.length * 100) + '%'; bar.appendChild(f); card.appendChild(bar);
            card.appendChild(el('p', 'eg-prompt', tr('cards_prompt')));
            card.appendChild(wordButtons(item, function (ord) {
                answers.push({ item: item, ord: ord, ok: ord === item.ord });
                i++;
                step();
            }));
            card.appendChild(el('p', 'eg-hint', item.hint));
            panel.appendChild(card);
        }
        function finish() {
            var right = answers.filter(function (a) { return a.ok; }).length, n = answers.length;
            // ошибки теста уходят в карточки: их вернёт тренировка
            var now = Date.now();
            answers.forEach(function (a) { C.grade(state, a.item.id, a.ok, now); });
            save();
            var box = el('div', 'eg-center');
            box.appendChild(el('p', 'eg-score', tr('test_result', { right: String(right), n: String(n) })));
            var share = right / n;
            box.appendChild(el('p', 'eg-lead', tr(share === 1 ? 'level_top' : share >= 0.85 ? 'level_good' : share >= 0.65 ? 'level_mid' : 'level_low')));
            var row = el('div', 'eg-actions eg-actions-center');
            var sh = el('button', 'eg-btn eg-btn-primary', tr('test_share')); sh.type = 'button';
            sh.addEventListener('click', function () { shareResult(right, n); });
            var again = el('button', 'eg-btn', tr('test_retry')); again.type = 'button';
            again.addEventListener('click', function () { runTest(C.testSet(LIST, 20, Math.random)); });
            row.appendChild(sh); row.appendChild(again);
            var wrongs = answers.filter(function (a) { return !a.ok; });
            if (wrongs.length) {
                var tr1 = el('button', 'eg-btn', tr('test_train')); tr1.type = 'button';
                tr1.addEventListener('click', function () { cardFilter = 'weak'; setMode('cards'); });
                row.appendChild(tr1);
            }
            box.appendChild(row);
            var rev = el('div', 'eg-review');
            rev.appendChild(el('h3', 'eg-h3', tr('test_mistakes_title')));
            if (!wrongs.length) rev.appendChild(el('p', 'eg-muted', tr('test_no_mistakes')));
            else {
                var ul = el('ul', 'eg-review-list');
                wrongs.forEach(function (a) {
                    var li = el('li');
                    li.appendChild(el('s', 'eg-was', C.shown(a.item, a.ord)));
                    li.appendChild(document.createTextNode(' → '));
                    li.appendChild(stressedHtmlNode(a.item));
                    li.appendChild(document.createTextNode(' '));
                    li.appendChild(sayButton([a.item.form]));
                    ul.appendChild(li);
                });
                rev.appendChild(ul);
            }
            panel.appendChild(box);
            panel.appendChild(rev);
            stage('test_done', { right: right, n: n });
            complete({ mode: 'test', right: right, n: n });
        }
        step();
    }
    function shareResult(right, n) {
        var text = tr('share_text', { right: String(right), n: String(n) });
        var url = CFG.shareUrl || location.href.split('?')[0];
        if (navigator.share) {
            navigator.share({ text: text, url: url }).catch(function () {});
            return;
        }
        var full = text + ' ' + url;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(full).then(function () { toast(tr('share_copied'), 'success'); }, function () {});
        }
    }

    // ── список: поиск, озвучка строки, PDF ─────────────────────────────────
    var search = document.getElementById('egSearch');
    var rows = document.querySelectorAll('#egList [data-k]');
    var nothing = document.getElementById('egNothing');
    if (search) {
        search.addEventListener('input', function () {
            var q = search.value.trim().toLowerCase().replace(/ё/g, 'е').replace(/́/g, '');
            var shownCount = 0;
            Array.prototype.forEach.call(rows, function (r) {
                var hit = !q || r.getAttribute('data-k').indexOf(q) >= 0;
                r.hidden = !hit;
                if (hit) shownCount++;
            });
            Array.prototype.forEach.call(document.querySelectorAll('#egList [data-eg-section]'), function (s) {
                s.hidden = !s.querySelector('[data-k]:not([hidden])');
            });
            if (nothing) nothing.hidden = shownCount > 0;
        });
    }
    Array.prototype.forEach.call(document.querySelectorAll('#egList .eg-say[data-forms]'), function (b) {
        b.addEventListener('click', function () {
            var forms = [];
            try { forms = JSON.parse(b.getAttribute('data-forms')) || []; } catch (_) {}
            playForms(forms);
        });
    });
    var pdfBtn = document.getElementById('egPdf');
    if (pdfBtn) {
        pdfBtn.addEventListener('click', function () {
            if (!window.__generatePDF) return;
            var list = document.getElementById('egListBody');
            pdfBtn.disabled = true;
            window.__generatePDF({
                element: list, filename: tr('list_pdf_name') + '.pdf', title: T.list_title,
                // на бумагу — список, без поиска, кнопок и динамиков
                onclone: function (doc) {
                    Array.prototype.forEach.call(doc.querySelectorAll('#egListBody [data-print-hide], #egListBody .eg-say, #egListBody [hidden]'),
                        function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
                }
            })
                .then(function () { pdfBtn.disabled = false; }, function () { pdfBtn.disabled = false; });
        });
    }

    // Озвучки нет на этом домене — кнопки не показываем вовсе.
    if (!CFG.audioUrl) document.body.classList.add('eg-no-audio');

    setMode(mode);
})();
